module.exports = __webpack_public_path__ + "img/4.b1a37f4e.png";